import styled from 'styled-components'
import { COLOR, FONT_SIZE } from '../../../themes'
const Style = styled.div`
  width: 100%;
  padding: 0 0 0 16px;
  box-sizing: border-box;
  height: calc(100% - 48px);
  max-height: 1080px;
  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-start;
  align-items: stretch;
  scroll-behavior: smooth;
  animation-timing-function: ease-out;
  transition: transform 200ms ease-in, max-width 0ms ease-in 200ms;
  overflow-y: scroll;

  .close-btn {
    position: absolute;
    right: 25px;
    top: 25px;
    width: 37px;
    height: 37px;
    padding: 3px;
    box-sizing: border-box;
  }
  .room-header {
    display: flex;
    flex-flow: column nowrap;
    margin: 25px 10px 0 0;
    justify-content: flex-start;
    align-items: stretch;
    margin-top: 2px;
  }
  .timeline-room-header-container {
    display: flex;
    flex-flow: row nowrap;
    margin: 10px 10px 10px 16px;
    justify-content: flex-start;
    align-items: flex-end;
    font-weight: bold;
    font-size: ${FONT_SIZE.LG2}
  }
  .room-name-text {
    line-height: 37px;
    height: 37px;
    align-self: center;
    text-align: center;
    font-weight: bold;
    padding: 0 0;
    margin: 0;
    font-size: ${FONT_SIZE.MD};
  }
  .room-name-subtext {
    line-height: 26px;
    height: 26px;
    align-self: center;
    text-align: center;
    font-weight: bold;
    padding: 0;
    margin: 0 0 0 0;
    font-size: ${FONT_SIZE.XXS};
  }
  
  .head_title {
    width: 100%;
    height: auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .head_left, .head_right {
    display: flex;
    align-items: center;
    gap: 16px;
  }

  .room_name {
    font-family: LibreBaskervilleBold, sans-serif;
    font-weight: 600;
    font-size: 32px;
    letter-spacing: 0;
    color: #363636;
    opacity: 1;
  }

  .type-badge {
    height: 24px;
    border-radius: 4px;
    padding: 0 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: NunitoSansRegular, sans-serif;
    font-size: ${FONT_SIZE.TN};
    font-weight: 500;
    box-sizing: border-box;
  }

  .status-badge {
    width: 76px;
    height: 24px;
    border-radius: 99px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: NunitoSansSemiBold, sans-serif;
    font-size: ${FONT_SIZE.TN};
    font-weight: 600;
    box-sizing: border-box;
  }

  .favorite-icon {
    position: relative;
    z-index: 10;
    cursor: pointer;
    display: flex;
    align-items: center;
  }
  .icon-btn {
    width: 100%;
    height: 100%;
  }
  .timeline-room-month-header {
    flex: 1;
    text-align: right;
    align-items: flex-end;
  }
  .timeline-room-container {
    margin: 0 auto 0 0;
    padding: 0;
  }
  .calendar-week-container {
    flex: 1;
    overflow: hidden;
    display: flex;
    flex-flow: column nowrap;
    justify-content: flex-end;
    align-items: center;
    -webkit-overflow-scrolling: touch;
    height: 88px;
    min-height: 88px;
    max-height: 88px;
  }
  .calendar-week-container > h4 {
    padding: 0;
    margin: 0;
    font-size: ${FONT_SIZE.LG2};
    font-weight: normal;
    color: ${COLOR.GOLD_1};
    font-weight: normal;
  }
  .calendar-week-container > p {
    padding: 0;
    margin: 0;
    font-size: ${FONT_SIZE.XXS};
    font-weight: normal;
    color: ${COLOR.GOLD_1};
    font-weight: bold;
  }
  .header-space {
    margin: 0 10px;
  }
  .header-subtext {
    color: ${COLOR.GRAY_3};
    cursor: pointer;
    margin-left: -8px;
  }
  .header-subtext:hover {
    color: ${COLOR.GRAY_10};
  }
  .header-subtext:active {
    color: ${COLOR.BLACK_1};
  }
`

export default Style
